export default __webpack_public_path__ + "static/media/vf-created.97965315.svg";